<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
  <Col :sm="24" :md="8" :lg="9" :xl="12">
    <Card class="card-box card-height">
      <div slot="header">
        ETA Compliance
      </div>
      <div class="text-center" v-if="isEtaComplianceLoading">
        <Spinner/>
      </div>
      <div class="status-msg" v-else-if="!etaCompliance">
        <span>
          <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
          <p class="mt-0 ml-30">No data available</p>
        </span>
      </div>
      <div class="chart-circle" v-else>
        <vue-circle
          ref="pickupComplianceRef"
          :progress="pickupCompliance"
          :size="160"
          :reverse="false"
          line-cap="round"
          :fill="fill1"
          empty-fill="#253E5B"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="10"
          :show-percent="false">
        </vue-circle>
        <vue-circle
          ref = "deliveredComplianceRef"
          :progress="deliveredCompliance"
          :size="120"
          :reverse="false"
          line-cap="round"
          :fill="fill2"
          empty-fill="#253E5B"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="10"
          :show-percent="false">
        </vue-circle>
      </div>

      <div class="chart-legend text-left" v-if="!isEtaComplianceLoading && etaCompliance">
        <ul>
          <Tooltip :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
            <div slot="content">
                <span v-html="trackingDashboard['pickupCompliance']"></span>
            </div>
              <li>
                <i class="icon-circle bg-blue-dark"></i>
                <label>Pickup Compliance</label>
                <span class="percent">{{ Number(pickupCompliance).toFixed(2) }}%</span>
              </li>
            </Tooltip>
            <Tooltip :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
              <div slot="content">
                <span v-html="trackingDashboard['deliveredCompliance']"></span>
              </div>
              <li>
                <i class="icon-circle bg-green-medium"></i>
                <label>Delivered Compliance</label>
                <span class="percent">{{ Number(deliveredCompliance).toFixed(2) }}%</span>
              </li>
          </Tooltip>
        </ul>
      </div>
    </Card>
  </Col>
</template>

<script>
import {
  filters,
} from '@/constants/trackConstants';
import VueCircle from 'vue2-circle-progress';
import SecFilterMixin from '@common/mixins/SecFilterMixin';


export default {
  components: {
    VueCircle,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      filters,
      isDarkTheme: true,
      fill1: { color: '#7467F0' },
      fill2: { color: '#4CD7A9' },
      startAngle: -Math.PI / 2,
    };
  },
  props: ['etaCompliance', 'isEtaComplianceLoading', 'emptyDashboardIcon', 'trackingDashboard'],
  computed: {
    pickupCompliance() {
      const percentage = this.etaCompliance ? this.etaCompliance.pickup : 0;
      const val = percentage > 0 ? percentage : 0;
      if (this.$refs.pickupComplianceRef) {
        this.$refs.pickupComplianceRef.updateProgress(val);
      }
      return val;
    },

    deliveredCompliance() {
      const percentage = this.etaCompliance ? this.etaCompliance.delivered : 0;
      const val = percentage > 0 ? percentage : 0;
      if (this.$refs.deliveredComplianceRef) {
        this.$refs.deliveredComplianceRef.updateProgress(val);
      }
      return val;
    },
  },
};
</script>

